<template lang="pug">
.demoModalComponent
  template(v-if="subscription.isNone")
    .title Для доступа к сервису нужно активировать демо-доступ
    .subtitle Срок демо-доступа #[span.days {{ daysLeftTextDefault }}] с даты активации
  template(v-else)
    .title У вас закончился срок демо-доступа
    .subtitle Для работы с сервисом необходимо<br> получить доступ к предметам
  .actions
    ui-button.button(
      @click="onCatalogButtonClick"
    ) Перейти в витрину
    ui-button.button(
      v-if="subscription.isNone"
      color="blue-outline"
      @click="onActivateButtonClick"
    ) Активировать демо-доступ

</template>

<script>
import { inject, computed } from 'vue'
import { useRouter } from 'vue-router'
import pluralize from '@/_core/helpers/pluralize'
import DemoController from '@/controllers/DemoController'

export default {
  inject: ['store'],
  emits: ['close'],
  setup (props, { emit }) {
    const store = inject('store')
    const router = useRouter()

    const subscription = computed(() => store.user.profile.subscription)

    const daysLeftTextDefault = computed(() => {
      return `${subscription.value.durationDefault}  ${pluralize(subscription.value.durationDefault, 'день', 'дня', 'дней')}`
    })

    const demoController = DemoController()

    const onActivateButtonClick = () => {
      demoController.requestActivate()
    }

    const close = () => emit('close')

    demoController.$on('requestActivateDemo-success', close)

    const onCatalogButtonClick = () => {
      router.push({ name: 'Catalog' })
      close()
    }

    const onBeforeClose = () => {
      demoController.$off('requestActivateDemo-success', close)
      return true
    }

    return {
      subscription,
      daysLeftTextDefault,
      onActivateButtonClick,
      onCatalogButtonClick,
      onBeforeClose
    }
  }
}
</script>

<style lang="sass" scoped>
.demoModalComponent
  max-width: 136*$u
  display: flex
  flex-flow: column
  align-items: center
  text-align: center
  padding: 0 8*$u
  margin: 0 auto

  > .title
    @include font('h3')
    max-width: 95*$u
    margin-bottom: 5*$u

  > .subtitle
    @include font('t18-regular')
    margin-bottom: 7*$u

    > .days
      color: $cBlue

  .actions
    display: flex
    flex-wrap: wrap
    justify-content: center
    gap: 5*$u
</style>
